/* SNKRSMOOD — Barre de navigation flottante au scroll
   Active la classe .header-floating sur le wrapper de l'entete et memorise la
   hauteur « au repos » de l'entete (--snkr-header-rest-height). Le style de la
   pilule est entierement gere par snkr-header-float.css ; le passage en mode
   « scrolle » reste pilote par header.js (classe .header-scrolled). */
(function () {
  'use strict';

  var FLOATING_CLASS = 'header-floating';
  var SCROLLED_CLASS = 'header-scrolled';

  function setup(header) {
    var section = header.closest('.header-section') || header.closest('.shopify-section');
    if (!section || section.dataset.snkrFloatReady === 'true') return;
    section.dataset.snkrFloatReady = 'true';

    var measure = function () {
      // Ne jamais mesurer en mode pilule : on veut la hauteur de l'entete au repos.
      if (section.classList.contains(SCROLLED_CLASS)) return;
      var height = Math.round(header.getBoundingClientRect().height);
      if (height > 0) {
        section.style.setProperty('--snkr-header-rest-height', height + 'px');
      }
    };

    measure();
    section.classList.add(FLOATING_CLASS);

    if (window.ResizeObserver) {
      new ResizeObserver(function () {
        window.requestAnimationFrame(measure);
      }).observe(header);
    } else {
      window.addEventListener('resize', measure);
    }

    if (window.MutationObserver) {
      new MutationObserver(function () {
        window.requestAnimationFrame(measure);
      }).observe(section, { attributes: true, attributeFilter: ['class'] });
    }
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var headers = scope.querySelectorAll('.header-section header[data-floating="true"]');
    Array.prototype.forEach.call(headers, setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
